import {
  AutomationActionWorkdayTriggerBusinessProcessDenormalized,
  IAutomationActionTemplateWorkdayTriggerBusinessProcess,
  WORKDAY_BP_CATALOG
} from '@dadohr/shared/domainTypes/experience';
import { useUnsafeTranslation } from '../../../../../../../i18next';
import { MinimalTaskBuilderContext } from '../../../TaskBuilder/types';
import { ActionDefinition } from '../../types';
import {
  ActionSummaryBody,
  ActionSummaryContainer,
  ActionSummaryHeading
} from '../shared';

/**
 * Read-only summary for a Workday "trigger business process" automation action:
 * the process label (template or denormalized runtime action — both carry it).
 * Field mappings are shown in the settings read-only view.
 */
export const ActionSummaryWorkday = ({
  a,
  def
}: {
  a:
    | IAutomationActionTemplateWorkdayTriggerBusinessProcess
    | AutomationActionWorkdayTriggerBusinessProcessDenormalized;
  expTpl: MinimalTaskBuilderContext;
  def: ActionDefinition;
}) => {
  const { t } = useUnsafeTranslation();
  const processLabel = WORKDAY_BP_CATALOG[a.process]?.label;
  return (
    <ActionSummaryContainer>
      <ActionSummaryHeading def={def} />
      <ActionSummaryBody>
        {processLabel ? t(processLabel) : def.description ?? def.shortLabel}
      </ActionSummaryBody>
    </ActionSummaryContainer>
  );
};
